import { z } from '@harvestiq/zod';
import { dbEvergreenSigningAgentSchema } from './db-evergreen-signing-agent';
import { dbSigningAgentSchema } from '../agents/db-signing-agent';

export const evergreenSigningAgentSchema = dbEvergreenSigningAgentSchema.extend(
  {
    latestSigningAgent: dbSigningAgentSchema.nullable(),
  }
);
export type EvergreenSigningAgent = z.infer<typeof evergreenSigningAgentSchema>;
